<template>
  <o-tooltip class="incidence-icon__tooltip" :label="incidence.incidence_name" variant="black">
    <div class="incidence-icon">
      <o-icon :style="iconStyle" :icon="icon" />
      <p @click="onClickMoreInfo">Ver más...</p>
    </div>
  </o-tooltip>
</template>

<script setup>
// Imports
import { computed } from 'vue';
import { INCIDENCE_ICONS } from '@/constants/incidences';

// Component Options

// Props and Emits
const props = defineProps({
  incidence: { type: Object, default: null },
});
const emit = defineEmits(['click:moreInfo']);

// Composition API Helpers

// Reactive Variables

// Computed Properties
const icon = computed(() => INCIDENCE_ICONS?.[props.incidence.incidence_name]?.icon || 'alert');
const iconStyle = computed(() => {
  const color = INCIDENCE_ICONS?.[props.incidence.incidence_name]?.color;
  return { color };
});
// Watchers

// Lifecycle Hooks

// Methods
const onClickMoreInfo = () => {
  emit('click:moreInfo', props.incidence);
};
</script>

<style scoped lang="sass">
.incidence-icon
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    width: 100%
    height: 100%
    &__tooltip
        width: 100%
        height: 100%
    & .icon
        cursor: default !important
        &:deep(i):before
            font-size: 32px
    & > p
        font-size: 10px
        margin: 0
        color: $color-blue-link
        text-decoration: underline
        cursor: pointer
        z-index: 2
</style>
